export default "__VITE_ASSET__Ca5Q$ue9__"